import * as React from 'react';
import type { SVGProps } from 'react';
const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M228 128C228 131.183 226.736 134.235 224.485 136.485C222.235 138.736 219.183 140 216 140H40C36.8174 140 33.7652 138.736 31.5147 136.485C29.2643 134.235 28 131.183 28 128C28 124.817 29.2643 121.765 31.5147 119.515C33.7652 117.264 36.8174 116 40 116H216C219.183 116 222.235 117.264 224.485 119.515C226.736 121.765 228 124.817 228 128Z"
      fill="currentColor"
    />
  </svg>
);
export default Minus;
